import { fadeIn, fadeOut } from 'dascat-utils';

export function toggleLoader (status, callback) {
  callback = callback || function () {};

  const loader = document.getElementById('loader');

  if (status) {
    fadeIn(loader, 200, function () {
      callback();
    });
  } else {
    fadeOut(loader, 200, function () {
      callback();
    });
  }
}

export function hideFormErrors() {
  const errorElList = document.getElementsByClassName('input-error');
  for (const errEl of errorElList) {
    errEl.classList.remove("input-error");
  }

  const errorDivList = document.getElementsByClassName('form-error-message');
  for (const errEl of errorDivList) {
    errEl.parentNode.removeChild(errEl);
  }
}

export function showFormGlobalError(formEl, errorMsg) {
  const msgEl = document.getElementById("form_error_msg");
  if (msgEl !== null) {
    msgEl.style.display = 'block';
    msgEl.innerHTML = errorMsg;
    formEl.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }
}

export function showFormErrors(formEl, errors) {

  hideFormErrors();

  let msg = '';
  for (const error of errors) {
    for (const property in error) {
      if (property === '') {
        msg += (`<p>${error[property]}</p>`);
      }

      let propertyEl = null;
      const propertyNodeList = formEl.querySelectorAll(`#${property}`);
      if (propertyNodeList.length != 0) {
        propertyEl = propertyNodeList[0];
        propertyEl.classList.add("input-error");
      }

      const errDivNodeList = formEl.querySelectorAll(`#${property}-error-div`);
      // vai dar sempre 0 ... pq temos o hideFormErrors ...
      // mas fica para a posteridade
      if (errDivNodeList.length == 0) {
        // const errorDiv = document.createElement("div");
        // errorDiv.id = `${property}-error-div`;
        // errorDiv.classList.add("form-error-message");
        // errorDiv.innerHTML = error[property];
        // propertyEl.parentNode.insertBefore(errorDiv, propertyEl.nextSibling);
        propertyEl.insertAdjacentHTML('afterend', `<div id="${property}-error-div" class="form-error-message"><p>${error[property]}</p></div>`);
      } else {
        const err_div = errDivNodeList[0];
        err_div.innerHTML = err_div.innerHTML + " " + error[property];
      }

    }
  }

  showFormGlobalError(formEl, 'Ocorreu um erro! Por favor, volte a tentar de novo.');
  if (msg != '') {
    showFormGlobalError(formEl, msg);
  }

}
